import { FaWhatsapp } from "react-icons/fa6";

export default function SupportButton() {
  const supportNumber = import.meta.env.VITE_WHATSAPP_SUPPORT_NUMBER as
    | string
    | undefined;

  if (!supportNumber) return null;

  return (
    <a
      href={`https://wa.me/${supportNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with support on WhatsApp"
      className="fixed z-20 bottom-[max(1.5rem,env(safe-area-inset-bottom))] right-6 flex items-center justify-center w-14 h-14 rounded-full bg-primary text-white shadow-lg hover:bg-primary/90 transition-colors"
    >
      <FaWhatsapp className="h-7 w-7" aria-hidden="true" />
    </a>
  );
}
